import { render, staticRenderFns } from "./VerticalNavMenuLink.vue?vue&type=template&id=4f86eb2e"
import script from "./VerticalNavMenuLink.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuLink.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuLink.vue?vue&type=style&index=0&id=4f86eb2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports